export const AUTHENTICATION_REQUIRED = 'authentication_required';
